import React from 'react'

const ResetIcon = ({ className, ...props }) => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
    >
        <path
            d="M5.24286 8.28663C6.05304 6.74058 7.34662 5.50192 8.92634 4.75955C10.5061 4.01717 12.2852 3.81182 13.9925 4.1748C15.6998 4.53779 17.2416 5.44919 18.3827 6.77002C19.5237 8.09085 20.2015 9.74863 20.3126 11.4906C20.4238 13.2325 19.9622 14.9629 18.9982 16.4181C18.0342 17.8732 16.6208 18.9731 14.9735 19.5501C13.3261 20.1272 11.5353 20.1496 9.87403 19.614C8.21277 19.0783 6.77227 18.0141 5.77219 16.5836"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.60918 5.40563L4.06572 8.71336C4.14846 9.3128 4.74046 9.70198 5.32358 9.54027L8.02896 8.78997"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default ResetIcon
